import { render, staticRenderFns } from "./GenericGridCard.vue?vue&type=template&id=0a44822e&scoped=true"
import script from "./GenericGridCard.vue?vue&type=script&lang=ts"
export * from "./GenericGridCard.vue?vue&type=script&lang=ts"
import style0 from "./GenericGridCard.vue?vue&type=style&index=0&id=0a44822e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a44822e",
  null
  
)

export default component.exports